<template>
  <section class="page-withdraw">
    <!-- 提现 -->
    <header class="withdraw-header main-second-bg gray-10-bd">
      <div class="flowingWater-nav a-3-bd">
        <c-navTab
          activeClassName="b-1-cl"
          activeColor="a-12-bg"
          className="b-2-cl"
          :currentTab="nowType"
          :navTab="navTab"
          lineHeight="55"
        />
      </div>
      <!-- 添加提币地址 -->
      <div class="goAddress blue-cl" @click="goAddress">
        <svg-icon icon-class="addsquare"></svg-icon>
        <span>{{ $t("assets.withdraw.addAddrss") }}</span>
      </div>
    </header>
    <div class="withdraw-details main-second-bg">
      <div class="details-left">
        <!-- 币种 -->
        <div class="coinType">
          <AssetCoinSelect withdraw v-model="symbol" @change="onSymbolChanged" init></AssetCoinSelect>
        </div>
        <div class="details-branch" v-if="haveBranch">
          <mainChain
            :branchTip="branchTip"
            :branchArr="branchArr"
            :activeBranch="activeBranch"
            @setActiveBranch="setActiveBranch"
          />
        </div>
        <template v-if="showAddress">
          <!-- 提币地址 -->
          <c-select
            :promptText="$t('assets.withdraw.CoinAddress')"
            :value="addressValue"
            :options="addressList"
            :errorHave="true"
            type="double"
            newStyleFormat
            @onChanges="addressChange"
            style="margin-bottom: 24px;"
          />
          <!-- 标签 -->
          <c-inputLine
            v-if="isHavePage"
            :errorHave="true"
            :promptText="$t('assets.withdraw.label')"
            :disabled="true"
            newStyleFormat
            :value="pagesValue"
          >
            <div class="addressBox-page-icon">
              <!-- <svg class="icon icon-14" aria-hidden="true">
                <use xlink:href="#icon-a_15"></use>
              </svg>
              <div class="addressBox-page-market a-4-bg">
                {{ $t("assets.withdraw.pageText") }}
              </div> -->
              <a-tooltip
                placement="bottom"
                :arrowPointAtCenter="true">
                <svg-icon class="icon icon-12" icon-class="rechargeTips"></svg-icon>
                <template slot="title">
                  <div class="addressBox-page-market">
                    {{ $t("assets.withdraw.pageText") }}
                  </div>
                </template>
              </a-tooltip>
            </div>
          </c-inputLine>
          <!-- 提币数量 -->
          <c-inputLine
            name="numberValue"
            :errorHave="true"
            :promptText="$t('assets.withdraw.NumberOfCoins')"
            @onchanges="inputChange"
            :value="numberValue"
            :placeholder="numberInputPlaceholder"
            newStyleFormat
            :errorFlag="numberOptions.error"
            :errorText="numberOptions.text"
          >
            <!-- 全部提现 -->
            <c-button type="text" height="30px" @click="allWithDraw" style="padding-right: 0;">
              {{ $t("assets.withdraw.allWithdraw") }}
            </c-button>
          </c-inputLine>
          <!-- 矿工手续费 -->
          <c-inputLine
            name="proceduresValue"
            :errorHave="true"
            disabled
            fill
            :promptText="$t('assets.withdraw.fee')"
            @onchanges="inputChange"
            :value="proceduresValue"
            newStyleFormat
          >
          </c-inputLine>
          <!-- 提现按钮 -->
          <c-button
            width="100%"
            marginTop="24px"
            height="40px"
            @click="withdrawClick"
            :disabled="btnDisabled"
            >{{ $t("assets.withdraw.buttonWithdraw") }}</c-button
          >
        </template>
        <div class="placeholder" v-else>
          <div class="holderImage">
            <svg-icon icon-class="stop"></svg-icon>
            <span class="text gray-cl">{{$t('assets.withdrawStop')}}</span>
          </div>
        </div>
      </div>
      <div class="details-right">
        <div class="numberList clearfix">
          <ul class="numberList-key">
            <!-- 总额 -->
            <li>{{ $t("assets.withdraw.lumpSum") }}</li>
            <!-- 可用 -->
            <li>{{ $t("assets.withdraw.Available") }}</li>
            <!-- 冻结 -->
            <li>{{ $t("assets.withdraw.freeze") }}</li>
          </ul>
          <ul class="numberList-value b-1-cl">
            <li v-for="(item, index) in detailsList" :key="index">
              <span class="value main-cl">{{ item.value | fixDFn(that) }}</span>
              <span class="unit main-cl">{{ showSymbol }}</span>
            </li>
          </ul>
        </div>
        <div v-if="symbol_withdraw_msg" class="withdrawMsg b-2-cl">
          <p class="main-cl title">{{ $t("application.applyRegion.focus") }}: </p>
          <template v-for="(item, key) in symbolWithdrawMsgArr">
            <p class="content" :key="key">{{ item }}</p>
          </template>
        </div>
      </div>
    </div>
    <!-- 最近提现记录 -->
    <header class="withdraw-header main-second-bg gray-10-bd">
      <!-- {{ $t('assets.withdraw.RecentWithdrawalRecords') }} -->
      <c-navTab
        activeClassName="b-1-cl"
        activeColor="a-12-bg"
        className="b-2-cl"
        :currentTab="nowTypeTable"
        :navTab="navTabTable"
        lineHeight="55"
      />
    </header>
    <div class="withdraw-table">
      <c-table
        :imgMap="imgMap"
        :colorMap="colorMap"
        :loading="tabelLoading"
        :columns="columns"
        :subContent="subTableData"
        :subContentId="subTableDataId"
        :subColumns="subColumns"
        :dataList="tabelList"
        @elementClick="tableClick"
      />
      <c-pagination
        v-if="paginationObj.total > paginationObj.display"
        :total="paginationObj.total"
        :display="paginationObj.display"
        :currentPage="paginationObj.currentPage"
        @pagechange="pagechange"
      />
    </div>
    <!-- 提示框 -->
    <c-verifyCationc-alert
      :showFlag="alertFlag"
      :imgMap="imgMap"
      :titleText="$t('assets.withdraw.safetyWarning')"
      :detaText="authTitleText"
      :dataList="alertData"
      :buttonText="$t('assets.withdraw.GotoOpen')"
      @close="alertClone"
      @confirm="alertGo"
    />
    <!-- 对话框  38-24=14 -->
    <c-dialog
      :showFlag="dialogFlag"
      paddingBottom="14px"
      :confirmLoading="dialogConfirmLoading"
      :confirmDisabled="dialogConfirmDisabled"
      @close="dialogClose"
      @confirm="dialogConfirm"
      :titleText="$t('assets.withdraw.safetyVerification')"
    >
      <!-- 手机号验证框 -->
      <c-inputLine
        v-if="OpenMobile"
        maxLength="6"
        name="phoneValue"
        :value="phoneValue"
        :promptText="$t('assets.withdraw.phoneCode')"
        :errorHave="true"
        :errorFlag="phoneError"
        :errorText="$t('assets.withdraw.phoneCodeError')"
        @onchanges="inputChange"
      >
        <!-- 获取验证码 -->
        <c-getCode name="withdrawGetcode" @click="getCodeClick" />
      </c-inputLine>
      <!-- 谷歌验证码 -->
      <c-inputLine
        v-if="OpenGoogle"
        maxLength="6"
        inputType="number"
        name="googleValue"
        :value="googleValue"
        :promptText="$t('assets.withdraw.googleCode')"
        :errorHave="true"
        :errorFlag="googleError"
        :errorText="$t('assets.withdraw.googleCodeError')"
        @onchanges="inputChange"
      />
    </c-dialog>
    <!-- 提示框 -->
    <c-alert
      :showFlag="notIdShowDialog"
      :buttonText="$t('otcRelease.DeCertification')"
      :imgMap="imgMap"
      @close="alertClone"
      @confirm="gotoAuth"
    >
      <div class="ts-content-text">
        {{ $t("personal.exccAuthForm.text19") }}
      </div>
    </c-alert>
  </section>
</template>
<script>
import mainChainMixins from 'BlockChain-ui-privatization/PC/common-mixin/assets/mainChainMixins';
import {
  fixD, fixInput, getCoinShowName, colorMap, imgMap, formatTime,
} from '@/utils';
import AssetCoinSelect from '@/views/components/AssetCoinSelect.vue';
import mainChain from './mainChain.vue';

export default {
  name: 'page-withdraw',
  mixins: [mainChainMixins],
  components: {
    mainChain,
    AssetCoinSelect,
  },
  data() {
    return {
      tabelLoading: false,
      imgMap,
      colorMap,
      alertFlag: false, // alert变量
      detailsList: [
        { key: 'sum', value: '--' },
        { key: 'normal', value: '--' },
        { key: 'lock', value: '--' },
      ],
      withdrawMin: '--', // 最小提币额度
      withdrawMax: '--', // 最大提币额度
      feeMin: '--', // 最小手续费
      feeMax: '--', // 最大手续费
      tabelList: [], // 提现记录
      subTableData: [], // 提现记录详情
      financeListData: [],
      subTableDataId: null, // 提现记录详情ID
      symbol: this.$route.query.symbol && this.$route.query.symbol.toUpperCase(),
      addressValue: '', // 提现地址
      detailsAddressList: {}, // axios返回的地址列表对象
      pagesValue: '', // 地址标签
      numberValue: '', // 提币数量
      proceduresValue: '', // 手续费
      addressList: [], // 提现地址列表
      havePageArr: ['XRP', 'EOS'], // 含有标签的币种
      paginationObj: {
        total: 0, // 数据总条数
        display: 10, // 每页显示条数
        currentPage: 1, // 当前页码
      },
      dialogFlag: false, // 弹窗开关
      dialogConfirmLoading: false, // 弹窗按钮loading
      googleValue: '', // 谷歌
      phoneValue: '', // 手机
      revokeList: [], // 撤销队列
      defaultFeeFlag: true,
      defaultFee: null,
      symbol_withdraw_msg: null,
      branchSymbolWithdrawMsg: '',
      branchTip: '', // 多主链提示
      notIdShowDialog: false,
      nowType: 1, // 1为站外提现2为站内提现
      nowTypeTable: 1, //
      showAddress: true,
      getBranchLoading: false,
    };
  },
  filters: {
    fixDFn(v, that) {
      return fixD(v, that.showPrecision);
    },
  },
  watch: {
    userInfoIsReady() {
      this.canAlert();
    },
    exchangeData(v) {
      if (v) {
        this.initDetails();
      }
    },
    paginationObjCurrentPage() {
      this.getTableList();
    },

    symbol: {
      immediate: true,
      handler() {
        this.pageInit();
      },
    },
    market: {
      immediate: true,
      handler() {
        this.pageInit();
      },
    },
    proceduresValue(v) {
      this.proceduresValue = fixInput(v, this.showPrecision);
    },
    numberValue(v) {
      this.numberValue = fixInput(v, this.showPrecision);
    },
  },
  computed: {
    symbolWithdrawMsgArr() {
      let arr = [];
      // 如果链上有注意事项则展示链上的注意事项,否则,展示主币的注意事项
      const message = this.branchSymbolWithdrawMsg || this.symbol_withdraw_msg;
      if (message) {
        const splitArr = message.split('\\n');
        arr = splitArr.filter(item => !!item);
      }
      return arr;
    },
    numberInputPlaceholder() {
      let placeholder = '';
      // 如果有链上的最大最小配置,优先取链上的配置,通知如论何时都展示最大最小提币金额
      placeholder += `${this.$t('assets.withdraw.MinimumCoinLimit')} ${this.removeTrailingZeros(this.withdrawMin)},`;
      placeholder += `${this.$t('assets.withdraw.MaximumCoinLimit')} ${this.removeTrailingZeros(this.withdrawMax)}`;
      return placeholder;
    },
    isHavePage() {
      let flag = false;
      // 判断market是否请求下来
      if (this.market && this.market.coinList) {
        if (!this.haveBranch) {
          // 判断market.coinList是否有当前币种
          if (this.market.coinList[this.symbol]) {
            const { tagType } = this.market.coinList[this.symbol];
            flag = tagType;
          }
        } else if (this.market.followCoinList[this.symbol][this.activeBranch]) {
          const { tagType } = this.market.followCoinList[this.symbol][this.activeBranch];
          flag = tagType;
        }
      }
      return flag;
    },
    showSymbol() {
      let str = this.symbol;
      if (this.market && this.market.coinList && this.market.coinList[this.symbol]) {
        str = getCoinShowName(this.symbol, this.market.coinList);
      }
      return str;
    },
    enforceGoogleAuth() {
      return this.$store.state.baseData.is_enforce_google_auth || 0;
    },
    authTitleText() {
      const text = this.enforceGoogleAuth
        ? 'assets.withdraw.enforceGoogleAuth'
        : 'assets.withdraw.safetyWarningError';
      return this.$t(text);
    },
    alertData() {
      const arr = [
        // 绑定谷歌验证
        { text: this.$t('assets.withdraw.bindGoogle'), flag: this.OpenGoogle },
      ];
      if (!this.enforceGoogleAuth) {
        // 绑定手机验证
        arr.push({ text: this.$t('assets.withdraw.bindPhone'), flag: this.OpenMobile });
      }
      return arr;
    },

    paginationObjCurrentPage() {
      return this.paginationObj.currentPage;
    },

    // 当前币种精度
    showPrecision() {
      let v = 0;
      const { market } = this.$store.state.baseData;
      if (market && market.coinList && market.coinList[this.symbol]) {
        v = market.coinList[this.symbol].showPrecision;
      }
      return v;
    },

    // 当前币种精度
    branchShowPrecision() {
      let v = 0;
      const { market } = this.$store.state.baseData;
      if (
        market
        && market.followCoinList
        && market.followCoinList[this.symbol]
        && market.followCoinList[this.symbol][this.activeBranch]
      ) {
        v = market.followCoinList[this.symbol][this.activeBranch].showPrecision;
      }
      return v;
    },

    // finance/account_balance 接口返回成功的数据
    exchangeData() {
      return this.$store.state.assets.exchangeData;
    },

    // market 接口
    market() {
      return this.$store.state.baseData.market;
    },

    // 提现按钮禁用状态
    btnDisabled() {
      let flag = true;
      if (this.addressValue.length && this.numberOptions.flag) {
        flag = false;
      }
      return flag;
    },

    // 表格title
    columns() {
      const list = [
        { title: this.$t('assets.withdraw.withdrawTime'), width: '15%' }, // 提现时间
        { title: this.$t('assets.withdraw.withdrawVolume'), width: '15%' }, // 提币数量
        { title: this.$t('assets.withdraw.withdrawFee'), width: '15%' }, // 网络手续费
        { title: this.$t('assets.flowingWater.withdrawRemarks'), width: '15%' }, // 标签
        { title: this.$t('assets.withdraw.withdrawStatus'), width: '15%' }, // 状态
        { title: this.$t('assets.withdraw.withdrawOptions'), width: '15%' }, // 操作
      ];
      return list;
    },

    subColumns() {
      return [
        this.$t('assets.flowingWater.withdrawAddress'), // 提币地址
        this.$t('assets.flowingWater.updataAt'), // 钱包处理时间
        this.$t('assets.flowingWater.txid'), // 区块链交易ID
      ];
    },

    userInfoIsReady() {
      return this.$store.state.baseData.userInfoIsReady;
    },

    // 用户是否开启手机
    OpenMobile() {
      let flag = false;
      const { userInfo } = this.$store.state.baseData;
      if (userInfo && userInfo.isOpenMobileCheck.toString() === '1') {
        flag = true;
      }
      return flag;
    },

    idAuth() {
      const { userInfo } = this.$store.state.baseData;
      let idAuth = 0;
      if (userInfo) {
        idAuth = Number(userInfo.authLevel);
      }
      return idAuth;
    },

    // 用户是否开启谷歌
    OpenGoogle() {
      let flag = false;
      const { userInfo } = this.$store.state.baseData;
      if (userInfo && userInfo.googleStatus.toString() === '1') {
        flag = true;
      }
      return flag;
    },
    // phoneValue 是否复合正则验证
    phoneValueFlag() {
      return this.$store.state.regExp.verification.test(this.phoneValue);
    },
    // googleValue 是否复合正则验证
    googleValueFlag() {
      return this.$store.state.regExp.verification.test(this.googleValue);
    },
    phoneError() {
      if (this.phoneValue.length !== 0 && !this.phoneValueFlag) return true;
      return false;
    },
    googleError() {
      if (this.googleValue.length !== 0 && !this.googleValueFlag) return true;
      return false;
    },
    // 弹窗确认按钮
    dialogConfirmDisabled() {
      let phone = true;
      let google = true;
      if (this.OpenMobile) {
        phone = this.phoneValueFlag;
      }
      if (this.OpenGoogle) {
        google = this.googleValueFlag;
      }
      if ((phone && google) || this.dialogConfirmLoading) {
        return false;
      }
      return true;
    },

    that() {
      return this;
    },

    // 提币数量的校验
    // 提现条件：
    // 1. 提现数量 > 手续费
    // 2. 提现数量 <= 可用余额 （提现数量包含手续费）
    // 3. 提现最小限额 =< 提现数量=<提现最大限额 20230615 修改 原来是"提现最小限额 =< (提现数量 -手续费) =<提现最大限额"
    numberOptions() {
      const obj = {
        text: '', // 错误提示文案
        flag: null, // 是否通过校验
        error: null, // 是否展示文案
      };
      const haveNum = parseFloat(this.detailsList[1].value) || 0; // 可用
      const minNum = parseFloat(this.withdrawMin) || 0; // 最小提币额
      const maxNum = parseFloat(this.withdrawMax) || 0; // 最大提币额
      // const daymaxNum = parseFloat(this.daywithdrawMax) || 0; // 单日最大提币额
      // const spk = fixD(this.numberValue - this.proceduresValue, this.showPrecision); // 提币数量减手续费
      if (this.numberValue.length === 0 || parseFloat(this.numberValue) === 0) {
        // 请输入提币数量
        obj.text = this.$t('assets.withdraw.NumberOfCoinsError');
        obj.flag = false;
        obj.error = false;
        return obj;
      }
      if (parseFloat(this.numberValue) <= parseFloat(this.proceduresValue)) {
        // 提币数量需大于矿工手续费
        obj.text = this.$t('assets.withdraw.NumberOfCoinsError2');
        obj.flag = false;
        obj.error = true;
        return obj;
      }
      if (parseFloat(this.numberValue) > haveNum) {
        // 提币数量不得大于可用余额
        obj.text = this.$t('assets.withdraw.NumberOfCoinsError3');
        obj.flag = false;
        obj.error = true;
        return obj;
      }
      if (parseFloat(minNum) > this.numberValue || parseFloat(maxNum) < this.numberValue) {
        // 提现最小限额 =< 提现数量=<提现最大限额
        obj.text = this.$t('assets.withdraw.NumberOfCoinsError4');
        obj.flag = false;
        obj.error = true;
        return obj;
      }
      obj.flag = true;
      obj.error = false;
      return obj;
    },
    baseData() {
      return this.$store.state.baseData.publicInfo;
    },
    // 提现是否开启了必须实名认证
    withdrawKycOpen() {
      let isOpen = 0;
      if (this.baseData && this.baseData.kycLimitConfig) {
        isOpen = this.baseData.kycLimitConfig.withdraw_kyc_open;
      }
      return Number(isOpen);
    },
    navTab() {
      const arr = [{ name: this.$t('assets.withdraw.withdraw'), index: 1 }]; // 站内
      return arr;
    },
    navTabTable() {
      const arr = [{ name: this.$t('assets.withdraw.RecentWithdrawalRecords'), index: 1 }]; // 站内];
      return arr;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.userInfoIsReady) {
        this.canAlert();
      }
    },

    /**
     * 币种发生变化
     */
    onSymbolChanged(symbol) {
      this.$router.push({ name: this.$route.name, query: { symbol } });
      this.pageInit();
    },

    pageInit() {
      this.defInit();
      if (this.symbol && this.market) {
        this.defaultFeeFlag = true;
        this.showAddress = true;
        this.haveBranch = false;
        this.branchInit(this.market);
        this.addressInit();
        this.initDetails();
      }
    },

    /**
     * 去掉小数点后的0，去掉小数点后尾数0.
     * 比如1.234000，显示1.234，1.0000显示1
     */
    removeTrailingZeros(num) {
      const number = Number(num);
      if (isNaN(number)) {
        return '';
      }
      const str = number.toFixed(10); // 保留最多 10 位小数
      return str.replace(/0+$/, '').replace(/\.$/, ''); // 去除尾数 0 和小数点
    },
    // 上半部分 左侧数据
    initDetails() {
      if (!this.exchangeData || !this.exchangeData.allCoinMap || !this.exchangeData.allCoinMap[this.symbol]) {
        return;
      }
      const obj = this.exchangeData.allCoinMap[this.symbol];
      const normalBalance = Number(obj.normal_balance) || Number(obj.overcharge_balance);
      this.detailsList = [
        { key: 'sum', value: fixD(obj.total_balance, this.showPrecision) }, // 总额
        { key: 'normal', value: fixD(normalBalance, this.showPrecision) }, // 可用
        { key: 'lock', value: fixD(obj.lock_balance, this.showPrecision) }, // 冻结
      ];
      this.symbol_withdraw_msg = obj.symbol_withdraw_msg || null; // 注意事项
      if (!this.haveBranch) {
        this.withdrawMin = fixD(obj.withdraw_min, this.showPrecision); // 最小提币额
        this.withdrawMax = fixD(obj.withdraw_max_day, this.showPrecision); // 最大提币额
        this.feeMin = fixD(obj.feeMin, this.showPrecision); // 最大手续费
        this.feeMax = fixD(obj.feeMax, this.showPrecision); // 最大手续费
        if (this.defaultFeeFlag) {
          this.defaultFeeFlag = false;
          this.defaultFee = `${obj.defaultFee}`;
          this.proceduresValue = `${obj.defaultFee}`; // 默认手续费
        }
      } else {
        this.getBranchAddress();
      }
    },

    getBranchAddress() {
      if (this.getBranchLoading) {
        return;
      }
      this.getBranchLoading = true;
      this.axios({
        url: 'cost/Getcost',
        params: {
          symbol: this.activeBranch,
        },
      }).then((data) => {
        this.getBranchLoading = false;
        if (data.code.toString() === '0') {
          this.showAddress = true;
          const list = [];
          const detailsList = {};
          const { userWithdrawAddrList } = data.data;
          userWithdrawAddrList.forEach((item) => {
            let value = item.address;
            if (this.isHavePage) {
              [value] = item.address.split('_');
            }
            list.push({
              code: `${item.id}`, value, label: item.remark, addressLabel: item.label,
            });
            detailsList[item.id] = item;
          });
          this.withdrawMax = fixD(data.data.withdraw_max_day, this.showPrecision);
          this.withdrawMin = fixD(data.data.withdraw_min, this.showPrecision);
          this.branchSymbolWithdrawMsg = data.data.symbol_withdraw_msg;
          this.feeMin = fixD(data.data.feeMin, this.branchShowPrecision); // 最大手续费
          this.feeMax = fixD(data.data.feeMax, this.branchShowPrecision); // 最大手续费
          if (this.defaultFeeFlag) {
            this.defaultFeeFlag = false;
            this.defaultFee = `${data.data.defaultFee}`;
            this.proceduresValue = `${data.data.defaultFee}`; // 默认手续费
          }
          this.branchTip = data.data.mainChainNameTip || 'tishitishitishithsihtithisi';
          this.addressList = list;
          this.detailsAddressList = detailsList;
        } else {
          this.showAddress = false;
          this.$bus.$emit('tip', {
            text: this.$t('assets.withdraw.notSupport'),
            type: 'error',
          });
        }
      }).catch(() => {
        this.getBranchLoading = false;
      });
    },

    // 获取提现地址
    getAddress() {
      if (this.haveBranch) {
        this.getBranchAddress();
        return;
      }
      this.axios({
        url: 'addr/address_list',
        params: {
          coinSymbol: this.haveBranch ? this.activeBranch : this.symbol,
        },
      }).then((data) => {
        if (data.code.toString() === '0') {
          const list = [];
          const detailsList = {};
          const { addressList } = data.data;
          addressList.forEach((item) => {
            let value = item.address;
            if (this.isHavePage) {
              [value] = item.address.split('_');
            }
            list.push({
              code: `${item.id}`, value, label: item.remark, addressLabel: item.label,
            });
            detailsList[item.id] = item;
          });
          this.addressList = list;
          this.detailsAddressList = detailsList;
        }
      });
    },

    defInit() {
      if (!this.exchangeData) {
        this.$store.dispatch('assetsExchangeData');
      } else {
        this.initDetails();
      }
    },

    setActiveBranch(v) {
      this.addressValue = ''; // 提现地址
      this.pagesValue = ''; // 地址标签
      this.numberValue = ''; // 提币数量
      this.defaultFee = '';
      this.defaultFeeFlag = true;
      this.proceduresValue = ''; // 手续费
      this.feeMin = '--';
      this.feeMax = '--';
      this.activeBranch = v;
      this.addressList = [];
      this.detailsAddressList = {};
      this.getAddress();
    },

    canAlert() {
      if (this.OpenGoogle || (!this.enforceGoogleAuth && this.OpenMobile)) {
        this.alertFlag = false;
      } else {
        setTimeout(() => {
          this.alertFlag = true;
        }, 100);
      }
    },

    alertClone() {
      this.alertFlag = false;
      this.notIdShowDialog = false;
    },

    alertGo() {
      this.$router.push('/personal/userManagement');
    },

    goAddress() {
      this.$router.push({
        path: '/assets/addressMent',
        query: {
          symbol: this.symbol,
        },
      });
    },

    inputChange(v, name) {
      this[name] = v;
    },

    addressInit() {
      // 获取table表数据
      this.getTableList();
      this.getAddress();
    },

    // 提现select框 change
    addressChange(item) {
      this.addressValue = item.code;
      if (this.isHavePage) {
        // const [, pagesValue] = this.detailsAddressList[item.code].address.split('_');
        this.pagesValue = item.addressLabel;
      }
    },
    // 全部提现
    allWithDraw() {
      if (this.detailsList[1].value === '--') return;
      this.numberValue = this.detailsList[1].value;
    },
    // 分页器
    pagechange(v) {
      this.paginationObj.currentPage = v;
    },
    // 获取验证码
    getCodeClick() {
      this.sendSmsCode();
    },
    // 发送验证码
    sendSmsCode() {
      this.axios({
        url: 'v4/common/smsValidCode',
        params: { operationType: '10' },
      }).then((data) => {
        if (data.code.toString() !== '0') {
          setTimeout(() => {
            // 倒计时重置
            this.$bus.$emit('getCode-clear', 'withdrawGetcode');
            // tip框提示错误
            this.$bus.$emit('tip', { text: data.msg, type: 'error' });
          }, 2000);
        } else {
          this.$bus.$emit('tip', {
            text: this.$t('assets.withdraw.phoneSendSuccess'),
            type: 'success',
          });
        }
      });
    },
    withdrawClick() {
      if (this.OpenGoogle || (!this.enforceGoogleAuth && this.OpenMobile)) {
        if (this.withdrawKycOpen && this.idAuth !== 1) {
          this.notIdShowDialog = true;
          return;
        }
        this.dialogFlag = true;
        return;
      }
      this.alertFlag = true;
    },
    // 弹窗关闭
    dialogClose() {
      this.phoneValue = '';
      this.googleValue = '';
      this.dialogFlag = false;
    },
    // 弹窗确认
    dialogConfirm() {
      this.dialogConfirmLoading = true;
      const pv = this.haveBranch ? this.branchShowPrecision : this.showPrecision;
      const amount = fixD(this.numberValue - this.proceduresValue, pv);
      this.axios({
        url: 'finance/do_withdraw',
        params: {
          addressId: this.addressValue, // 提现地址id
          fee: this.proceduresValue, // 手续费
          amount, // 提现金额（不包含手续费
          googleCode: this.googleValue,
          smsAuthCode: this.phoneValue,
          symbol: this.haveBranch ? this.activeBranch : this.symbol,
        },
      }).then((data) => {
        this.dialogConfirmLoading = false;
        if (data.code.toString() === '0') {
          this.getTableList(); // 获取列表
          this.$store.dispatch('assetsExchangeData'); // 更新额度
          this.$bus.$emit('tip', { text: data.msg, type: 'success' });
          this.addressValue = '';
          this.pagesValue = '';
          this.numberValue = '';
          this.proceduresValue = this.defaultFee;
          this.phoneValue = '';
          this.googleValue = '';
          this.dialogFlag = false;
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
    // 撤销操作
    tableClick(type, id) {
      if (type === 'revoke') {
        let even = {};
        this.tabelList.forEach((item) => {
          if (item.id === id) {
            even = item;
          }
        });
        if (this.revokeList.indexOf(even.id) === -1) {
          this.revokeList.push(even.id);
          this.axios({
            url: '/finance/cancel_withdraw',
            headers: {},
            params: {
              withdrawId: even.id,
            },
            method: 'post',
          }).then((data) => {
            const ind = this.revokeList.indexOf(even.id);
            this.revokeList.splice(ind, 1);
            if (data.code.toString() === '0') {
              this.getTableList();
              this.$store.dispatch('assetsExchangeData'); // 更新额度
              this.$bus.$emit('tip', { text: data.msg, type: 'success' });
            } else {
              this.$bus.$emit('tip', { text: data.msg, type: 'error' });
            }
          });
        }
      }
      if (type === 'subView') {
        this.subTableDataId = id.id;
        this.subTableData = [];
        this.financeListData.forEach((item) => {
          if (item.id === this.subTableDataId) {
            let address = item.addressTo;
            if (this.isHavePage) {
              const [newAddress] = address.split('_');
              address = newAddress;
            }
            this.subTableData.push([
              address, // 地址
              item.walletTime ? formatTime(item.walletTime) : '---',
              item.txid || '---',
            ]);
          }
        });
      }
    },
    // 获取提现记录数据
    getTableList() {
      if (!this.symbol || this.tabelLoading) {
        return;
      }

      this.tabelLoading = true;
      this.axios({
        url: 'record/new_withdraw_list',
        params: {
          pageSize: this.paginationObj.display, // 每页条数
          page: this.paginationObj.currentPage, // 页码
          coinSymbol: this.symbol,
          type: this.nowTypeTable,
        },
      }).then((data) => {
        this.tabelLoading = false;
        if (data.code.toString() === '0') {
          const list = [];
          this.financeListData = data.data.financeList;
          data.data.financeList.forEach((item) => {
            if (this.nowTypeTable === 1) {
              list.push({
                id: item.id,
                data: [
                  item.createdAt, // 时间
                  fixD(item.amount, this.showPrecision), // 充值数量
                  fixD(item.fee, this.showPrecision), // 手续费
                  item.remark, // 备注
                  item.status_text, // 状态
                  this.handleButton(item),
                ],
              });
            } else if (this.nowTypeTable === 2) {
              list.push({
                id: item.id,
                data: [
                  item.createdAt, // 时间
                  item.addressTo, // 对方账号
                  fixD(item.amount, this.showPrecision), // 充值数量
                  fixD(item.fee, this.showPrecision), // 手续费
                  item.status_text, // 状态
                ],
              });
            }
          });
          this.tabelList = list;
          this.paginationObj.total = data.data.count > 30 ? 30 : data.data.count;
        }
      }).catch(() => {
        this.tabelLoading = false;
      });
    },
    handleButton(item) {
      const arr = [];
      if (item.status === 0) {
        arr.push({
          type: 'button', // 'link' ' button' ,'html', 'label', 'icon' ‘str’
          text: this.$t('assets.flowingWater.Cancel'),
          iconClass: [''],
          eventType: 'revoke',
        });
      }
      arr.push({
        type: 'subTable',
        text: this.$t('trade.view'), // 详情
        eventType: 'subView',
      });
      return arr;
    },
    // 去认证
    gotoAuth() {
      this.$router.push('/personal/userManagement');
    },
  },
};
</script>
<style lang="scss" scoped>
.page-withdraw {
  .addressBox-page-icon {
    line-height: 28px;
    cursor: pointer;
    position: relative;
  }
  .withdraw-header {
    height: 55px;
    line-height: 55px;
    padding-left: 20px;
    font-size: 14px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
  }
  .goAddress {
    display: flex;
    gap: 6px;
    align-items: center;
    font-size: 12px;
    margin-right: 24px;
    cursor: pointer;
    float: right;
  }
  .withdraw-details {
    padding: 24px;
    gap: 24px;
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;

    .details-left {
      flex: 1;
      .coinType {
        display: flex;
        gap: 8px;
        flex-direction: column;
        margin-bottom: 24px;

        .label {
          font-size: 12px;
        }

        .symbol {
          border-radius: 4px;
          padding: 14px 16px;
          font-size: 14px;
        }
      }

      .details-branch {
        margin-bottom: 24px;
      }


      .placeholder {
        width: 100%;
        height: 258px;
        position: relative;
        .holderImage {
          position: absolute;
          top: 50%;
          left: 50%;
          font-size: 96px;
          transform: translate(-50%, -50%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .text {
            font-size: 14px;
          }
        }
      }

      /deep/ .input-line-label {
        font-size: 12px;
      }
    }
    .details-right {
      margin-top: 24px;
      width: 380px;
    }
    .numberList {
      display: flex;
      justify-content: space-between;
      font-size: 14px;

      ul {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 26px;
      }
      .numberList-key {
        text-align: left;
      }

      .numberList-value {
        text-align: right;

        li {
          display: flex;
          gap: 16px;
          justify-content: flex-end;
        }
      }
      .numberList-last {
        margin-left: 64px;
      }
    }

    .ServiceSpk {
      font-size: 12px;
      line-height: 30px;
      padding-right: 5px;
    }

    .details-warking {
      font-size: 12px;
      .dayMax {
        margin-left: 28px;
        margin-top: 10px;
      }
    }
  }
  .withdraw-table {
    width: 100%;
    box-sizing: border-box;
    .table-head,
    .table-body-bar,
    .pagination {
      padding: 0 !important;
    }
  }
}
.withdrawMsg {
  margin-top: 30px;
  font-size: 12px;
  line-height: 18px;

  .title {
    font-size: 14px;
    margin-bottom: 12px;
  }

  .content {
    line-height: 18px;
    margin-bottom: 16px;

    &::before {
      display: inline-block;
      content: "";
      width: 5px;
      height: 5px;
      background-color: #878999;
      border-radius: 50%;
      transform: translate(0px, -2px);
      margin-right: 4px;
    }
  }
}
.addressBox-page-market {
  width: 340px;
  padding: 20px;
  box-sizing: border-box;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 20px;
}
</style>
